import { render, staticRenderFns } from "./Vips.vue?vue&type=template&id=479d6ac6&scoped=true&"
import script from "./Vips.vue?vue&type=script&lang=js&"
export * from "./Vips.vue?vue&type=script&lang=js&"
import style0 from "./Vips.vue?vue&type=style&index=0&id=479d6ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d6ac6",
  null
  
)

export default component.exports